// extracted by mini-css-extract-plugin
export default {"status":"IsPaidStatus_status__bY317","paid":"IsPaidStatus_paid__a33IC","unpaid":"IsPaidStatus_unpaid__wEUfj"};